import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import { CaptionText } from '@prisjakt/ui/text/variants';

export const PriceList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  > li:not(:last-child) {
    margin-bottom: ${layout.measurements.spacing050};
  }
`;

export const PricePanel = styled.div`
  margin-bottom: 20px;

  ${media.mediumUp`
    margin-bottom: 30px;
  `}

  > ul:not(:last-child) {
    margin-bottom: ${layout.measurements.spacing100};
  }
`;

export const PartnerOffersTitle = styled(CaptionText)`
  display: block;
  margin-bottom: ${layout.measurements.spacing050};

  ${media.mediumUp`
    display: none;
  `}
`;

export const HeaderWrapper = styled.div`
  margin-top: ${layout.measurements.spacing150};
  margin-bottom: ${layout.measurements.spacing100};
`;
